<template>
  <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content">
    <div class="modal-header">
      <div class="mx-auto">Alertas Electronicas</div>
      <button class="btn-close-modal me-1" @click="closeModal()"><i></i></button>
    </div>
    <div class="row modal-box">
      <form method="post" action="#" name="contact-form" id="contact-form">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">Nombre<span class="text-danger"> *</span> :</label>
              <input name="name" id="name" type="text" class="form-control" />
            </div>
          </div>
          <!--end col-->
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">Apelidos<span class="text-danger"> *</span> :</label>
              <input name="name" id="name" type="text" class="form-control" />
            </div>
          </div>
          <!--end col-->
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">Correo<span class="text-danger"> *</span> :</label>
              <input name="email" id="email" type="email" class="form-control" />
            </div>
          </div>
          <!--end col-->
          <div class="col-md-12">
            <div class="form-check">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input" name="" id="" value="checkedValue" checked />
                Suscribirse para recibir todas las noticias por correo electrónico de puerto antioquia.
              </label>
            </div>
          </div>
        </div>
        <!--end row-->
        <div class="row mt-3">
          <div class="col-sm-12 d-grid">
            <button class="submitBnt btn btn-custom" type="buttom" @click.prevent="closeModal()">SUSCRIBIR</button>
            <!-- <input type="submit" id="submit" name="send" class="submitBnt btn btn-custom" value="SUSCRIBIR" /> -->
            <div id="simple-msg"></div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </form>
    </div>
  </vue-final-modal>
  <!-- <button @click="openModal()">Open Modal</button> -->
</template>

<script>
export default {
  name: 'Newsletter',

  data() {
    return {
      showModal: false,
    }
  },
  mounted() {
    setTimeout(() => this.openModal(), 7000)
  },
  methods: {
    openModal() {
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
  },
}
</script>
<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep(.modal-content) {
  width: 600px;
  display: flex;
  flex-direction: column;
  margin: 0 1rem;

  /* border: 1px solid #e2e8f0; */
  border-radius: 0.25rem;
  background: #fff;
}
::v-deep(.modal-box) {
  padding: 2rem 3rem;
}
.modal-header {
  padding: 5px 10px;
  font-size: 1.5rem;
  /* font-weight: 700; */
  text-align: center;
  color: #fff;
  background-color: #09485C;
}
</style>

<style scoped>
.dark-mode div::v-deep(.modal-box) {
  border-color: #2d3748;
  background-color: #1a202c;
}
.btn-close-modal {
  cursor: pointer;
}
</style>
